import { MeTabPage } from "@features/me/components/MeTabPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/me/$tab")({
	component: MeTabPage,
});
